<template>
<div>
    <!-- modal -->
    <b-modal id="nationalTrademarkSearchHistoryFormModal" centered size="lg" no-close-on-backdrop ref="nationalTrademarkSearchHistoryFormModal" :title=" $t('nationalTrademarkSearchHistory.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-row>
                <b-col class="col-md-12">
                    <b-form-group>
                        <label for="national-trademark-search-history-date">{{ $t('nationalTrademarkSearchHistory.date') }}</label>
                        <CustomDatePicker :datePickerValidateOption="0" v-model="date"></CustomDatePicker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-md-12">
                    <label for="national-trademark-search-history-status">{{ $t('nationalTrademarkSearchHistory.status') }}</label>
                    <b-form>
                        <validation-provider :name="$t('nationalTrademarkSearchHistory.status')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                            <b-form-select :state="errors.length > 0 ? false : null" v-model="nationalTrademarkSearchHistoryStatusSelect" value-field="id" text-field="name" :options="nationalTrademarkSearchHistoryStatusOption" size="sm" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form>
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>    
export default {
    props: {
        nationalTrademarkSearchId: Number,
        getNationalTrademarkSearchHistoryList: {
            type: Function
        },
        getNationalTrademarkSearchList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            nationalTrademarkSearchHistoryStatusSelect: 0,
            nationalTrademarkSearchHistoryStatusOption: [],
            date: null,
            employeeId: '',
            locale: this.$i18n.locale,
        }
    },
    methods: {
        showInfo(id, nationalTrademarkSearchId) {
            this.$refs['nationalTrademarkSearchHistoryFormModal'].show()
            this.id = id
            this.nationalTrademarkSearchId = nationalTrademarkSearchId
            const data = {
                id: this.id
            }
            const controller = {
                name: 'NationalTrademarkSearchHistory'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.nationalTrademarkSearchHistoryStatusSelect = response.data.nationalTrademarkSearchHistory.nationalTrademarkSearchStatusId
                    this.nationalTrademarkSearchHistoryStatusOption = response.data.nationalTrademarkSearchStatusList
                    this.employeeId = response.data.nationalTrademarkSearchHistory.employeeId
                    this.date = response.data.nationalTrademarkSearchHistory.date
                    this.nationalTrademarkSearchHistoryStatusOption.splice(0, 0, this.$nullSelected())
                } else {
                    this.$bvModal.hide('nationalTrademarkSearchHistoryFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                nationalTrademarkSearchId: this.nationalTrademarkSearchId,
                nationalTrademarkSearchStatusId: this.nationalTrademarkSearchHistoryStatusSelect,
                employeeId: localStorage.getItem('EmployeeId'),
                date: this.date
            }
            const controller = {
                name: 'NationalTrademarkSearchHistory'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('nationalTrademarkSearchHistoryFormModal')
                            this.getNationalTrademarkSearchHistoryList()
                            this.getNationalTrademarkSearchList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

.btn-group,
.btn-group-vertical {
    position: relative;
    display: inline-flex;
    vertical-align: middle;
    height: 2.7em;
}

[dir] .btn-secondary {
    border: 1px solid #7367f0 !important;
    background-color: transparent !important;
}
.datepickerStyle{
    max-height: 2.2em;
    font-family: fangsong;
}
</style>
